export default {"src":"/_next/static/media/drag-and-drop.3ca5aa65.svg","height":40,"width":40};